import { isNamedNode, sym } from "rdflib";
import { dc, vcard } from "../namespaces.js";
import { generateId } from "@solid-data-modules/rdflib-utils/identifier";
export class AddressBookQuery {
    constructor(store, addressBookNode) {
        this.store = store;
        this.addressBookNode = addressBookNode;
        this.addressBookDoc = addressBookNode.doc();
    }
    proposeNewContactNode() {
        return this.proposeNewNode("Person");
    }
    proposeNewGroupNode() {
        return this.proposeNewNode("Group");
    }
    proposeNewNode(containerPath) {
        const id = generateId();
        const baseUri = this.addressBookNode.dir()?.uri;
        return sym(`${baseUri}${containerPath}/${id}/index.ttl#this`);
    }
    queryTitle() {
        return (this.store.anyValue(this.addressBookNode, dc("title"), undefined, this.addressBookDoc) ?? "");
    }
    queryNameEmailIndex() {
        const index = this.store.any(this.addressBookNode, vcard("nameEmailIndex"), undefined, this.addressBookDoc);
        if (isNamedNode(index)) {
            return index;
        }
        else {
            return null;
        }
    }
    queryContacts() {
        const nameEmailIndex = this.queryNameEmailIndex();
        return nameEmailIndex && isNamedNode(nameEmailIndex)
            ? this.store
                .each(null, vcard("inAddressBook"), this.addressBookNode, nameEmailIndex)
                .filter((it) => isNamedNode(it))
                .map((node) => ({
                name: this.store.anyValue(node, vcard("fn"), null, nameEmailIndex) ??
                    "",
                uri: node.value,
            }))
            : [];
    }
    queryGroupIndex() {
        const index = this.store.any(this.addressBookNode, vcard("groupIndex"), undefined, this.addressBookDoc);
        if (isNamedNode(index)) {
            return index;
        }
        else {
            return null;
        }
    }
    queryGroups() {
        const groupIndex = this.queryGroupIndex(); //?
        return groupIndex && isNamedNode(groupIndex)
            ? this.store
                .each(this.addressBookNode, vcard("includesGroup"), null, groupIndex)
                .filter((it) => isNamedNode(it))
                .map((node) => ({
                name: this.store.anyValue(node, vcard("fn"), null, groupIndex) ?? "",
                uri: node.value,
            }))
            : [];
    }
}
//# sourceMappingURL=AddressBookQuery.js.map